import '../../../../../../../../scss/_rentalUnitsUnitInfoTable.scss';
import { ShowIf } from '../../../../../../../../components/ShowIf';
import { Occupied } from '../../components/Occupied';
import { AnnualRent } from '../../components/AnnualRent';
import { Bathrooms } from '../../components/Bathrooms';
import { Bedrooms } from '../../components/Bedrooms';
import { SquareFeet } from '../../components/SquareFeet';
import { GarageBays } from '../../components/GarageBays';

interface UnitInformationRowsProps {
    unitGuid: string;
    includeOccupied: boolean;
    isReview?: boolean;
}

export const UnitInformationTableRows: React.FC<UnitInformationRowsProps> = ({ unitGuid, includeOccupied, isReview = false }) => {
    const itemClassName = 'col';

    return (
        <>
            <ShowIf showIf={includeOccupied}>
                <div className={itemClassName}>
                    <Occupied
                        unitGuid={unitGuid}
                        width='100%'
                        required={true}
                        showLabel={false}
                        isReview={isReview}
                    />
                </div>
            </ShowIf>

            <div className={itemClassName}>
                <AnnualRent
                    unitGuid={unitGuid}
                    required={true}
                    showLabel={false}
                    isReview={isReview}
                />
            </div>

            <div className={itemClassName}>
                <SquareFeet
                    unitGuid={unitGuid}
                    required={true}
                    showLabel={false}
                    isReview={isReview}
                />
            </div>

            <div className={itemClassName}>
                <Bedrooms
                    unitGuid={unitGuid}
                    required={true}
                    showLabel={false}
                    isReview={isReview}
                />
            </div>

            <div className={itemClassName}>
                <Bathrooms
                    unitGuid={unitGuid}
                    required={true}
                    showLabel={false}
                    isReview={isReview}
                />
            </div>

            <div className={itemClassName}>
                <GarageBays
                    unitGuid={unitGuid}
                    required={true}
                    showLabel={false}
                    isReview={isReview}
                />
            </div>
        </>
    );
};
